import { vars } from "@common/styles";
import { Flex as BaseFlex } from "@common/styles/reusable/Flex/Flex.styles";
import styled, { css } from "styled-components";

import BaseButton from "../../Button/Button";

export const Flex = styled(BaseFlex)<{ $hasSeparator?: boolean }>`
  padding-top: 2.4rem;
  width: 100%;
  position: relative;

  ${(props) =>
    props.$hasSeparator &&
    css`
      margin-top: 2.4rem;
      border-top: 1px solid ${vars.colors.grey90};
    `}
`;

export const Button = styled(BaseButton)<{ $hasPaddingRight?: boolean }>`
  ${(props) =>
    props.$hasPaddingRight &&
    css`
      margin-right: 1.6rem;
    `}

  &:focus-visible {
    outline: -webkit-focus-ring-color auto 0px;
  }
`;
